import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateJobPostModel, JobPost, EditJobPostModel } from "../../models/inModels/JobPost";

@Injectable()
export class JobPostService {
	private routeCategory = '/api/jobposts';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<JobPost> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobPost)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateJobPostModel): Promise<JobPost> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobPost)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditJobPostModel): Promise<JobPost> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobPost)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/business/job-post.service.ts